import React, { useState, useEffect } from 'react';
import { Image, PictureAsPdf, Grade, ChevronRight, KeyboardArrowDown, CloudDownload, Audiotrack, Link } from '@mui/icons-material';
import { Button, Collapse, Box, LinearProgress, List, Stack, Typography, Tooltip, Grid } from '@mui/material';
import Scrollbars from 'react-custom-scrollbars';
import { ReactComponent as IconVideo } from 'assets/images/icons/c-icono-video.svg';
import { ReactComponent as IconLectura } from 'assets/images/icons/c-icono-ojo-abierto.svg';
import { ReactComponent as IconEvaluacion } from 'assets/images/icons/c-icono-evaluacion.svg';
import { makeStyles, withStyles } from '@mui/styles';
import { styled, useTheme } from '@mui/material/styles';

const style = {
    boxCursos: {
        boxShadow: 0,
        borderRadius: 0,
        width: '100%',
        mt: 1
    }
};

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 6,
        borderRadius: 0
    },
    colorPrimary: {
        backgroundColor: theme.palette.dark[100]
    },
    bar: {
        borderRadius: 0,
        backgroundColor: theme.palette.success.dark
    }
}))(LinearProgress);

const ContentButton = (props) => {
    const { tipo, data, id, open, calificacion, listaItems } = props;

    const expandIcon = `${tipo}${id}` == open ? <KeyboardArrowDown color="black" /> : <ChevronRight color="black" />;

    const getPorcentaje = (listaItems) => {
        const numItems = listaItems?.length;
        let completos = 0;
        listaItems?.forEach((element) => {
            if (element.isAprobado == 1 && element.calificacion != null) {
                completos = completos + 1;
            }
        });

        const resultado = Math.round((completos / numItems) * 100);
        return isNaN(resultado) ? 0 : resultado;
    };

    const getCalificacion = (listaItems) => {
        const numItems = listaItems?.length;
        let sumCalif = 0;
        listaItems?.forEach((element) => {
            if (element.isAprobado == 1 && element.calificacion != null) {
                sumCalif = sumCalif + Number(element.calificacion);
            }
        });

        const resultado = (sumCalif / numItems).toFixed(2);
        return isNaN(resultado) ? 0 : resultado;
    };

    return (
        <Grid container sx={{ backgroundColor: props.theme.palette.secondary.light }}>
            <Grid item xs={12} sx={{ backgroundColor: props.theme.palette.secondary.light }} display="flex" justifyContent="start">
                {expandIcon}
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="cardTemarioTitle">{data.titulo}</Typography>
                    <Typography variant="caption">{data.descact}</Typography>
                </div>
            </Grid>
            <Grid item xs={12} sx={{ backgroundColor: props.theme.palette.background.default }}>
                <Stack sx={{ width: '100%', p: 1, pb: 0 }}>
                    <props.BorderLinearProgress variant="determinate" value={getPorcentaje(listaItems)} />
                    <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                        <props.IconTooltip title="Progreso">
                            <Typography sx={{ ml: 0.5 }} variant="cardTemarioFooter">
                                {`${getPorcentaje(listaItems)}%`}
                            </Typography>
                        </props.IconTooltip>
                        <Grade style={{ ...props.theme.typography.iconDefault, margin: '0px 5px 0px 5px' }} color="warning" />
                        <props.IconTooltip title="Promedio">
                            <Typography variant="cardTemarioFooter">{getCalificacion(listaItems)}</Typography>
                        </props.IconTooltip>
                    </Box>
                </Stack>
            </Grid>
        </Grid>
    );
};

const DetalleActividad = (props) => {
    const { detalleActividades, listaDetalles } = props;
    return (
        <List>
            {listaDetalles?.map((detalleActividad, key) => (
                <div key={`detalleActividad${detalleActividad.idDetalleActividad}`}>
                    <div>
                        <Button
                            sx={{
                                ...style.boxCursos,
                                display: 'flex',
                                justifyContent: 'start',
                                backgroundColor: props.theme.palette.secondary.light
                            }}
                            onClick={() => {
                                props.handleDetalleActividad({
                                    ...detalleActividad,
                                    idActividad: props.idActividad,
                                    idTemario: detalleActividad.idTemario,
                                    idSesion: props.idSesion,
                                    idCurso: props.idCurso,
                                    califAprobatoria: props.califAprobatoria
                                });
                            }}
                            color="inherit"
                            disabled={props.revisaDependencias(
                                listaDetalles
                                    .filter((actividad) => actividad.idCalificacionDetalle != null && actividad.isAprobado == 1)
                                    .map((act) => act.idDetalleActividad),
                                JSON.parse(detalleActividad.dependencia)?.map((act) => act.idDetalleActividad)
                            )}
                        >
                            <props.IconTooltip title={detalleActividad.idCalificacionDetalle ? 'Concluida' : 'Sin responder'}>
                                <props.IconType
                                    type={detalleActividad.idTipoActividad}
                                    isAprobado={detalleActividad.isAprobado}
                                    style={{
                                        ...props.theme.typography.iconDefault,
                                        marginRight: '5px'
                                    }}
                                    {...props}
                                />
                            </props.IconTooltip>

                            <Typography>{detalleActividad.titulo}</Typography>
                        </Button>
                    </div>
                </div>
            ))}
        </List>
    );
};

const Actividad = (props) => {
    const { listaActividades, actividades, detalles } = props;
    const getFullDetalles = (actividad) => {
        let arrAct = [];

        let act = detalles;
        act.forEach((element) => {
            if (actividad.idActividad == element.idActividad) {
                arrAct.push(element);
            }
        });
        return arrAct;
    };
    return (
        <List sx={{ pl: 1, pr: 1 }}>
            {listaActividades?.map((actividad) => (
                <div key={`actividades${actividad?.idActividad}`}>
                    <div>
                        <Button
                            sx={{ ...style.boxCursos, backgroundColor: props.theme.palette.secondary.light }}
                            onClick={() => {
                                props.cambiarOpenA(`actividades${actividad?.idActividad}`);
                            }}
                            color="inherit"
                            disabled={props?.revisaDependencias(
                                listaActividades
                                    ?.filter((act) => act?.idCalificacionActividad != null && act?.isAprobado == 1)
                                    .map((act) => act?.idActividad),
                                JSON.parse(actividad?.dependencia)?.map((act) => act?.idActividad)
                            )}
                        >
                            <ContentButton
                                tipo="actividades"
                                data={actividad}
                                id={actividad?.idActividad}
                                calificacion={actividad?.calificacion}
                                open={props.openA}
                                listaItems={getFullDetalles(actividad)}
                                {...props}
                            />
                        </Button>
                        <Collapse in={`actividades${actividad?.idActividad}` == props.openA} timeout="auto" unmountOnExit>
                            <DetalleActividad listaDetalles={getFullDetalles(actividad)} idActividad={actividad?.idActividad} {...props} />
                        </Collapse>
                    </div>
                </div>
            ))}
        </List>
    );
};

const Sesion = (props) => {
    const { sesiones, actividades } = props;
    const getFullActividades = (sesion) => {
        let arrAct = [];

        let act = actividades;
        act.forEach((element) => {
            if (sesion.idSesion == element.idSesion) {
                arrAct.push(element);
            }
        });

        return arrAct;
    };

    const getTemarioId = (sesion) => {
        let temarioTrainer = sesion.temarios.find((element) => Number(element.orden) === 1);

        if (!temarioTrainer || temarioTrainer == -1) {
            return sesion.temarios[0].idTemario;
        } else {
            return temarioTrainer.idTemario;
        }
    };
    return (
        <List sx={{ backgroundColor: props.theme.palette.background.default, p: 0 }}>
            {sesiones?.map((sesion) => (
                <div key={`sesion${sesion.idSesion}`}>
                    <div>
                        <Button
                            sx={{ ...style.boxCursos, backgroundColor: props.theme.palette.secondary.light, m: 0 }}
                            onClick={() => {
                                props.cambiarOpenS(`sesion${sesion.idSesion}`);
                            }}
                            color="inherit"
                            disabled={props.revisaDependencias(
                                sesiones
                                    ?.filter((ses) => ses.idCalificacionSesion != null && ses.isAprobado == 1)
                                    .map((ses) => ses.idSesion),
                                JSON.parse(sesion.dependencia)?.map((ses) => ses.idSesion)
                            )}
                        >
                            <ContentButton
                                tipo="sesion"
                                data={sesion}
                                id={sesion.idSesion}
                                calificacion={sesion.calificacion}
                                open={props.openS}
                                listaItems={getFullActividades(sesion)}
                                {...props}
                            />
                        </Button>
                        <Collapse in={`sesion${sesion.idSesion}` == props.openS} timeout="auto" unmountOnExit>
                            {/* actividades={temario.actividades} idTemario={temario.idTemario} */}
                            {/* {props.curso.tipoCurso == 2 ? ( */}
                            <Actividad
                                idSesion={sesion.idSesion}
                                idTemario={sesion.idTemario}
                                listaActividades={getFullActividades(sesion)}
                                // idTemario={getTemarioId(sesion)}
                                {...props}
                            />
                            {/* ) : (
                                <Temario temarios={sesion.temarios} idSesion={sesion.idSesion} {...props} />
                            )} */}
                        </Collapse>
                    </div>
                </div>
            ))}
        </List>
    );
};

const TemarioV2 = (props) => {
    const { isLoading, ctl, onclick, curso, temario } = props;
    const theme = useTheme();

    const handleDetalleActividad = (id) => {
        onclick(id);
    };

    // Functions
    const revisaDependencias = (arrActividadesRespondidas, arrDependencias) => {
        if (arrDependencias && arrDependencias.length > 0) {
            const arrEmpate = arrActividadesRespondidas.filter((id) => arrDependencias.includes(id));
            // Checamos si las actividades respondidas son las mismas de dependencia
            if (arrEmpate.length >= arrDependencias.length) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    // Components
    const IconTooltip = ({ title, children }) => (
        <Tooltip title={title} disableInteractive>
            {children}
        </Tooltip>
    );
    const IconType = (props) => {
        const { type, isAprobado, style } = props;
        // const color = () => {
        //     if (Number(isAprobado) == 1) return props.theme.palette.success.main;
        //     if (Number(isAprobado) == 0) return props.theme.palette.error.main;
        //     if (isAprobado == null) return props.theme.palette.dark.main;
        //     return 'white';
        // };
        const color = (aprob) => {
            if (!aprob || aprob == null) {
                return props.theme.palette.dark.main;
            } else {
                return Number(aprob) == 1 ? props.theme.palette.success.main : props.theme.palette.error.main;
            }
        };
        const modifyStyle = { ...style, fill: color(isAprobado) };
        let icon = null;
        switch (type) {
            case '1':
                icon = <IconLectura style={modifyStyle} />;
                break;
            case '2':
                icon = <IconVideo style={modifyStyle} />;
                break;
            case '3':
            case '7':
                icon = <IconEvaluacion style={modifyStyle} />;
                break;
            case '4':
                icon = <PictureAsPdf style={modifyStyle} />;
                break;
            case '5':
                icon = <Image style={modifyStyle} />;
                break;
            case '6':
                icon = <CloudDownload style={modifyStyle} />;
                break;
            case '8':
                icon = <Audiotrack style={modifyStyle} />;
                break;
            case '9':
                icon = <Link style={modifyStyle} />;
                break;
            default:
                icon = null;
                break;
        }
        return icon;
    };

    const propsTemarios = {
        theme: theme,
        idCurso: curso?.idCurso,
        tipoCurso: curso?.tipoCurso,
        califAprobatoria: curso?.califAprobatoria,
        sesiones: temario?.sesiones,
        actividades: temario?.actividades,
        detalles: temario?.detalles,
        handleDetalleActividad: handleDetalleActividad,
        revisaDependencias: revisaDependencias,
        IconTooltip: IconTooltip,
        IconType: IconType,
        BorderLinearProgress: BorderLinearProgress,
        ContentButton: ContentButton,
        ...props
    };

    return (
        <>
            <Scrollbars style={{ height: '70vh' }}>
                {/* <Curso /> */}
                <Sesion {...propsTemarios} />
            </Scrollbars>
        </>
    );
};

export default TemarioV2;
